import React, { useState, useEffect } from 'react';
import {
    Typography,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    TextField,
    Alert
} from '@mui/material';
import { useUpdate, useRecordContext } from 'react-admin';
import EditIcon from '@mui/icons-material/Edit';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import AdapterDateFns from '@mui/lab/AdapterDateFns'; // Assicurati di aver installato il pacchetto @mui/lab
import { editButtonCss, saveButtonCss, cancelButtonCss } from "../shared/Styles/buttonStyles";
import { it } from 'date-fns/locale';

const DialogDataScadenza = () => {
    const record = useRecordContext();
    const [open, setOpen] = useState(false);
    const [newValue, setNewValue] = useState(new Date());
    const [errorMessage, setErrorMessage] = useState('');
    const [update, { loading, error }] = useUpdate();

    useEffect(() => {
        if (record) {
            const scadenza = record.dataScadenza ? new Date(record.dataScadenza) : new Date();
            if (!record.dataScadenza) {
                scadenza.setDate(scadenza.getDate() + 7);
            }
            setNewValue(scadenza);
        }
    }, [record]);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = () => {
        const today = new Date();
        today.setDate(today.getDate() + 1); // Domani
        if (newValue < today) {
            setErrorMessage('La data di scadenza deve essere almeno un giorno avanti da oggi.');
            return;
        }

        update('tbl-quiz',
            { id: record.id, data: { dataScadenza: newValue.toISOString() }, previousData: record },
            {
                onSuccess: ({ data }) => {
                    setOpen(false);
                    // Se vuoi aggiornare il record nel genitore, potresti dover chiamare una funzione di refresh qui
                },
                onFailure: (error) => {
                    // Gestisci l'errore
                    console.error(error);
                }
            }
        );
    };

    return (
        <>
            <IconButton aria-label="Modifica" sx={editButtonCss} onClick={handleClickOpen}>
                <EditIcon />
            </IconButton>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Modifica data di scadenza</DialogTitle>
                <DialogContent>
                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={it}>
                        <DatePicker
                            label="Data Scadenza"
                            value={newValue}
                            onChange={(newDate) => {
                                setNewValue(newDate);
                                setErrorMessage('');
                            }}
                            renderInput={(params) => <TextField {...params} />}
                            minDate={new Date()} // Imposta la data minima a oggi
                        />
                    </LocalizationProvider>
                    {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" sx={cancelButtonCss}>
                        Annulla
                    </Button>
                    <Button onClick={handleSave} color="primary" disabled={loading} sx={saveButtonCss}>
                        Salva
                    </Button>
                </DialogActions>
                {error && <Typography color="error">{error.message}</Typography>}
            </Dialog>
        </>
    );
};

export default DialogDataScadenza;
